import React, { createContext, useState, useContext } from 'react';

const LoadingContext = createContext(null);

export function LoadingProvider({ children }) {
  const [loadingCount, setLoadingCount] = useState(0);
  const startLoading = () => setLoadingCount((c) => c + 1);
  const stopLoading = () =>
    setLoadingCount((c) => Math.max(c - 1, 0));
  const loading = loadingCount > 0;
  return (
    <LoadingContext.Provider value={{ loading, startLoading, stopLoading }}>
      {children}
    </LoadingContext.Provider>
  );
}

export function useLoading() {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useLoading must be used within LoadingProvider');
  }
  return context;
}
